import styled, { css } from "styled-components";

export const FormGroup = styled.div`
  .input-group {
    &.pwd-field {
      .form-control {
        box-shadow: none;
      }
      .input-group-text {
        background: #e7e7e7;
        color: #495057;
        font-size: 22px;
      }
    }
  }
`;

export const FormLabel = styled.div`
  ${({ theme, fontsize, labelcolor }) => css`
    font-size: ${fontsize === "small" ? 15 : 20}px;
    font-weight: 200;
    color: ${labelcolor === "light" ? theme.colors.lightGrey : ""};
    font-family: "Raleway", sans-serif;
    line-height: 32px;
  `}
`;

export const Fields = styled.input`
  ${({ theme, fontsize, backcolor, height, width, error }) => css`
    height: ${height === "small" ? 15 : 50}px;
    font-size: ${fontsize === "small" ? 13 : 20}px;
    width: ${width ? width : 100}%;
    background: ${backcolor === "grey"
      ? theme.colors.gstGrey
      : theme.colors.gstWhite};
    padding: 8px;
    border-radius: 2px;
    border: 1px solid ${error ? theme.colors.gstRed : "#d9d9d9"};
    position: relative;
    &:focus {
      outline: none;
      color: ${theme.colors.gstBlue};
      box-shadow: 0 0 0 1px ${theme.colors.gstBlue};
    }
  `}
`;

export const Error = styled.span`
  ${({ top }) => css`
    font-size: 0.8em;
    font-weight: 600;
    color: red;
    position: relative;
    top: ${top === "top" ? -10 : 0}px;
    display: inline-block;
  `}
`;
